import { RicosPluginToolbarNames } from 'ricos-types';
import type { EditorPluginCreator } from 'wix-rich-content-common';

import { InsertModal } from './components/insert-modal';
import { SettingsModal } from './components/settings-modal';
import { getAddButtons } from './getAddButtons';
import { getToolbarButtons } from './getToolbarButtons';
import { tiptapExtensions } from './tiptap/tiptap';
import type { PollPluginEditorConfig } from './types';
import { POLL_TYPE } from './types';

export const pluginPoll: EditorPluginCreator<
  PollPluginEditorConfig,
  { InsertModal: typeof InsertModal; SettingsModal: typeof SettingsModal }
> = config => {
  return {
    config: config ?? {},
    type: POLL_TYPE,
    tiptapExtensions,
    getAddButtons: (config, services) => getAddButtons(config, services),
    toolbar: {
      names: [RicosPluginToolbarNames.POLL],
      getButtons: (config, services) => getToolbarButtons(config, services),
    },
    __exports: {
      InsertModal,
      SettingsModal,
    },
  };
};
